import { useAuth } from "../context/AuthContext";

export const IsSuperUser = () => {
  const { user } = useAuth();
  return user?.is_superuser || false;
};

export const IsAdmin = () => {
  const { user } = useAuth();
  return user?.role_details?.[0]?.name === "System Admin" || false;
};

export const IsSeniorAccountant = () => {
  const { user } = useAuth();
  return user?.role_details?.[0]?.name === "Senior Accountant" || false;
};

export const IsSeniorCreditManager = () => {
  const { user } = useAuth();
  return user?.role_details?.[0]?.name === "Senior Credit Manager" || false;
};
